module.exports = __webpack_public_path__ + "img/gb.99676a11.svg";